import { normalizeLocale } from './normalize'

export function getLocaleFromPath(pathname, baseUrl, availableLocales) {
  let clearPath = String(pathname || '').split(/[?#]/, 1)[0]
  const normalizedBaseUrl = String(baseUrl || '').replace(/\/$/, '')
  const hasBasePath =
    normalizedBaseUrl && (clearPath === normalizedBaseUrl || clearPath.startsWith(`${normalizedBaseUrl}/`))

  if (hasBasePath) {
    clearPath = clearPath.slice(normalizedBaseUrl.length)
  }

  const firstPathSegment = clearPath.split('/').find(Boolean)
  return normalizeLocale(firstPathSegment, availableLocales)
}

function decodeRedirectPath(value) {
  let decodedValue = String(value || '')

  for (let attempt = 0; attempt < 3; attempt++) {
    try {
      const nextValue = decodeURIComponent(decodedValue)
      if (nextValue === decodedValue) {
        break
      }
      decodedValue = nextValue
    } catch {
      break
    }
  }

  return decodedValue
}

export function readRedirectLocale(search, baseUrl, availableLocales, enabled) {
  if (!enabled) {
    return null
  }

  const searchParams = new URLSearchParams(String(search || '').replace(/^\?/, ''))
  const explicitLocale = normalizeLocale(searchParams.get('mirror_locale'), availableLocales)

  if (explicitLocale) {
    return explicitLocale
  }

  const redirectPath = searchParams.get('path') || searchParams.get('url')

  if (!redirectPath) {
    return null
  }

  return getLocaleFromPath(decodeRedirectPath(redirectPath), baseUrl, availableLocales)
}
